import { render } from "./usergroupview.vue?vue&type=template&id=f8f73388"
import script from "./usergroupview.vue?vue&type=script&lang=js"
export * from "./usergroupview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__